import { useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import { useDefaultCadastroStyles } from '../cadastros/components/default-cadastro-styles';
import { PropagandaCriacaoHeader } from './components/propaganda-criacao-header/propaganda-criacao-header';
import { PropagandaCriacaoContent } from './components/propaganda-criacao-content/propaganda-criacao-content';
import { useStyles } from './propaganda-criacao-styles';


const PropagandaCriacaoPage = () => {
    const defaultClasses = useDefaultCadastroStyles();
    const [openPesquisa, setOpenPesquisa] = useState(false);
    const classes = useStyles()

    return (
        <Grid className={defaultClasses.root}>
            <Grid className={defaultClasses.header}>
                <PropagandaCriacaoHeader
                    openPesquisa={openPesquisa}
                    setOpenPesquisa={setOpenPesquisa}
                />
            </Grid>
            <Box className={classes.box}>
                <Grid
                    container
                    className={classes.height}
                >
                    <Grid item xs={12}>
                        <PropagandaCriacaoContent />
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default PropagandaCriacaoPage;

